<template>
    <div class="box-container">
        <div class="box-container-header">
            <h2 class="box-title">
                {{ $t('DASHBOARD.TITLE.SUMMARY') }}<!--요약-->
                <button type="button" class="buttons-icon" data-type="ghost" data-size="xs" data-icon="info" data-trigger="tooltip" :title="$t('DASHBOARD.SUMMARY.TOOLTIP.SUMMARY')">info</button>
            </h2>

            <div class="actions">
                <router-link v-bind:to="'/compliance'" class="buttons" data-type="ghost" data-size="s" data-icon-right="open"><span class="open">{{ $t('DASHBOARD.SUMMARY.BUTTON.VIEW_EVAL_LIST')}}<!--검사 목록 보기--></span></router-link>
                <router-link v-bind:to="'/audit'" class="buttons" data-type="ghost" data-size="s" data-icon-right="open"><span class="open">{{ $t('DASHBOARD.SUMMARY.BUTTON.VIEW_EVAL_HIST')}}<!--검사 실행 이력 보기--></span></router-link>

                <!-- 관리 버튼 툴팁 메뉴 -->
                <dashboard-widget v-bind:type="'summary'"></dashboard-widget>

            </div>
        </div>
        <div class="compliance-summary" v-if="!pending">
            <div class="compliance-score">
                <h3 class="title">
                    {{ $t('DASHBOARD.SUMMARY.EVAL_SCORE') }}<!--검사 점수-->
                    <button type="button" class="buttons-icon" data-type="ghost" data-size="xs" data-icon="info" data-trigger="tooltip" :title="$t('DASHBOARD.SUMMARY.TOOLTIP.EVAL_SCORE')">info</button>
                </h3>

                <strong class="score">{{ round(scoreObj.totRate) }} %</strong>

                <div class="bar-graph">
                    <div class="base-number">
                        <span>0%</span>
                        <span>50%</span>
                        <span>100%</span>
                    </div>
                    <ul class="bar">
                        <li class="success" data-trigger="tooltip" data-tooltip-content="#tooltip-success01" v-bind:style="{width: scoreObj.sucsRate+'%'}">{{$t('AUDIT.LABEL.CASE.SUCCESS')}}</li>
                        <li class="failer" data-trigger="tooltip" data-tooltip-content="#tooltip-failer01" v-bind:style="{width: scoreObj.failRate+'%'}">{{$t('AUDIT.LABEL.CASE.FAILURE')}}</li>
                        <li class="error" data-trigger="tooltip" data-tooltip-content="#tooltip-error01" v-bind:style="{width: scoreObj.errorRate+'%'}">{{$t('AUDIT.LABEL.CASE.ERROR')}}</li>
                    </ul>
                </div>

                <div class="tooltip_templates">
                    <div id="tooltip-success01">
                        <p class="tooltip-score">{{ $t('DASHBOARD.SUMMARY.PASSED_RULES')}}<!--성공한 규칙--> &nbsp;&nbsp;&nbsp;{{round( scoreObj.sucsRate )}}% | {{ scoreObj.sucsCnt }}{{ $t('COMMON.UNIT.EA')}}</p>
                    </div>
                </div>
                <div class="tooltip_templates">
                    <div id="tooltip-failer01">
                        <p class="tooltip-score">{{ $t('DASHBOARD.SUMMARY.FAILED_RULES')}}<!--실패한 규칙--> &nbsp;&nbsp;&nbsp;{{round( scoreObj.failRate )}}% | {{ scoreObj.failCnt }}{{ $t('COMMON.UNIT.EA')}}</p>
                    </div>
                </div>
                <div class="tooltip_templates">
                    <div id="tooltip-error01">
                        <p class="tooltip-score">{{ $t('DASHBOARD.SUMMARY.ERROR_RULES')}}<!--에러난 규칙--> &nbsp;&nbsp;&nbsp;{{round( scoreObj.errorRate )}}% | {{ scoreObj.errorCnt }}{{ $t('COMMON.UNIT.EA')}}</p>
                    </div>
                </div>
            </div>

            <div class="compliance-info">
                <ul class="list-info">
                    <li>{{ $t('DASHBOARD.SUMMARY.DESCRIPTION_EVALUATED', {'plcyCnt':scoreObj.plcyCnt, 'ruleCnt':scoreObj.totCnt})}}<!--총 {000}개의 정책과 {0000}개의 규칙을 검사하였습니다.--></li>
                    <li>{{ $t('DASHBOARD.SUMMARY.DESCRIPTION_RESULT', {'passCnt':scoreObj.sucsCnt, 'failCnt':scoreObj.failCnt, 'errCnt':scoreObj.errorCnt})}}<!--검사 결과: {0000}개 성공, {000}개 실패, {000}개 에러--></li>
                    <li>
                        {{ $t('DASHBOARD.SUMMARY.NUMBER_OF_RULES_BY_SEVERITY') }}<!--심각도 별 규칙 수-->
                        <div class="result-count">
                            <div class="segmented-control">
                                <input type="radio" id="result01" name="result" v-bind:checked="selSevirity == 'fail'"
                                       v-on:change="changeSelSevirity('fail')">
                                <label for="result01">{{ $t('DASHBOARD.SUMMARY.TAB.FAIL') }}<!--실패--></label>

                                <input type="radio" id="result02" name="result" v-bind:checked="selSevirity == 'sucs'"
                                       v-on:change="changeSelSevirity('sucs')">
                                <label for="result02">{{ $t('DASHBOARD.SUMMARY.TAB.PASS') }}<!--성공--></label>
                            </div>

                            <ul class="list-results">
                                <li v-for="index in 4" style="cursor: pointer" :key="index">
                                    <a class="btn-link" :data-success="selSevirity == 'sucs'" :data-failer="selSevirity == 'fail' || selSevirity == 'error' " v-on:click="moveComplianceList(selSevirity, index)">
                                        <span class="icon-serious" data-align="vertical" :data-status="index == 1 ? 'critical' : index == 2 ? 'high' : index == 3 ? 'medium' : 'low'">{{$t('LABEL.SVRTY.'+(5-index))}}</span>
                                        <strong class="count">
                                            <template v-if="sevirityObjList[index-1]">
                                                {{ (selSevirity == 'fail') ? sevirityObjList[index - 1].failCnt : (selSevirity == 'sucs') ? sevirityObjList[index - 1].sucsCnt : sevirityObjList[index - 1].errorCnt }}
                                            </template>
                                            <template v-else>
                                                0
                                            </template>
                                        </strong>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div-loading v-if="pending"></div-loading>
    </div>


</template>

<script>
import DashboardWidget from "./dashboardWidget.vue";
import {mapGetters} from "vuex";

export default {
    name: 'DashboardSummary',
    components: {
        DashboardWidget
    },
    props: ['filter'],
    data: function () {
        return {
            rawDataList: [],
            scoreObj: {
                failCnt: 0,
                sucsCnt: 0,
                errorCnt: 0,
                totCnt: 0,                   // sucsCnt + failCnt + errorCnt

                failRate: 0,                 // failCnt / (sucsCnt + failCnt) * 100
                sucsRate: 0,                 // sucsCnt / (sucsCnt + failCnt) * 100
                errorRate: 0,
                totRate: 0,                // sucsCnt / (sucsCnt + failCnt + errorCnt) * 100
                plcyCnt: 0
            },
            selSevirity: 'fail',
            sevirityObjList: [],
            pending: false
        }
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
    },
    methods: {
        initView() {
            let target = $('[data-trigger="tooltip"]');
            target.tooltipster({
                delay: 300,
                // trigger: 'click',
                animation: 'fade',
                updateAnimation: 'fade',
                side: 'bottom',
                arrow: true,
                contentAsHTML: true,
                interactive: true,
                functionPosition: function(instance, helper, position){
                    if (position.coord.left < 52) {
                        position.coord.left = 52;
                    }
                    return position;
                }
            });
        },
        // summary - rule pass score of all compliance
        selectDashboardSummaryRawData() {
            this.pending = true
            var url = `/api/governance/dashboard/summary`
            var header = {
                'cmpnId': this.curCmpnId
            };

            this.http.post(url, JSON.stringify(header))
                .then(response => {
                    this.pending = false
                    if (response.data.status === 'ok') {
                        this.rawDataList = response.data.result.list;
                        this.applyFilterRawData();

                        this.$nextTick(function () {
                            this.initView();
                        })
                    }
                })
        },
        applyFilterRawData() {
            let self = this;
            let data = this.rawDataList;

            // account filter 적용
            if (this.filter != null && this.filter.acnt != null && typeof (this.filter.acnt) !== 'undefined' && this.filter.acnt.length > 0) {
                data = _.filter(data, function (o) {
                    let isInclude = false;
                    for (let acnt of self.filter.acnt) {
                        isInclude = _.includes(o.acnt, acnt)
                        if (isInclude) break;
                    }
                    return isInclude;
                });
            }

            this.setScoreData(data);
            this.setSevirityData(data);
        },
        setScoreData(data) {
            this.scoreObj.totCnt = data.length;
            this.scoreObj.sucsCnt = _.filter(data, function (o) {
                return (o.cmplRslt && (o.cmplRslt == 'P'))
            }).length;
            this.scoreObj.failCnt = _.filter(data, function (o) {
                return (o.cmplRslt && (o.cmplRslt == 'F'))
            }).length;
            this.scoreObj.errorCnt = _.filter(data, function (o) {
                return (o.cmplRslt && (o.cmplRslt == 'E'))
            }).length;

            if (this.scoreObj.totCnt > 0 && (this.scoreObj.failCnt > 0 || this.scoreObj.sucsCnt > 0)) { // 분모 0 처리
                this.scoreObj.totRate = this.scoreObj.sucsCnt / this.scoreObj.totCnt * 100;
                this.scoreObj.sucsRate = this.scoreObj.sucsCnt / this.scoreObj.totCnt * 100;
                this.scoreObj.failRate = this.scoreObj.failCnt / this.scoreObj.totCnt * 100;
                this.scoreObj.errorRate = this.scoreObj.errorCnt / this.scoreObj.totCnt * 100;

            } else {
                this.scoreObj.totRate = 0;
                this.scoreObj.sucsRate = 0;
                this.scoreObj.failRate = 0;
                this.scoreObj.errorRate = 0;

            }

            this.scoreObj.plcyCnt = Object.keys((_.groupBy(data, 'rsltId'))).length;

        },
        // sevirity 별로 , fail,pass 개수 group by
        setSevirityData(data) { // sevirity 1==낮음
            this.sevirityObjList = [];
            let self = this;
            _.forEach(_.groupBy(data, 'svrty'), function (value, key) {
                let temp = _.groupBy(value, 'cmplRslt');
                let obj = {
                    "svrty": parseInt(key),
                    "failCnt": temp.F ? temp.F.length : 0,
                    "sucsCnt": temp.P ? temp.P.length : 0,
                    "errorCnt": temp.E ? temp.E.length : 0
                }
                self.sevirityObjList.push(obj);
            });

            for (let i = 0; i < 4; i++) {
                let findIndex = _.findIndex(self.sevirityObjList, {'svrty': i + 1});

                if (findIndex == -1) {
                    let obj = {
                        "svrty": i + 1,
                        "failCnt": 0,
                        "sucsCnt": 0
                    }
                    self.sevirityObjList.push(obj);
                }
            }
            this.sevirityObjList = _.reverse(_.sortBy(self.sevirityObjList, function (o) {
                return o.svrty
            }));
        },
        changeSelSevirity(sel) {
            this.selSevirity = sel;
        },
        moveComplianceList(selSevirity, index) {
             const severity = 5 - index;
            var status = '';
            if(selSevirity=='sucs') status = 'P';
            if(selSevirity=='fail') status = 'F';
            if(selSevirity=='error') status = 'E';
            this.$router.push({path: '/compliance', query: {ruleCmplRslt: status, severity: severity}});
        },
        round(i) {
            return this.Common.round(i, 2);
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/dashboard/dashboardSummary.vue